
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5.344h-7.703V10H20V5.344z","fill":"#ED6B47"}}),_c('path',{attrs:{"d":"M20 10h-7.703v4.656H20V10z","fill":"#DC512B"}}),_c('path',{attrs:{"d":"M12.297 5.344H4.609V10h7.688V5.344z","fill":"#107C41"}}),_c('path',{attrs:{"d":"M12.297 14.656V10H4.625v8.391c0 .5.406.906.906.906h13.547c.5 0 .906-.406.906-.906v-3.735h-7.687z","fill":"#C8421D"}}),_c('path',{attrs:{"d":"M19.078.703h-6.797V5.36H20V1.61a.93.93 0 00-.922-.906z","fill":"#FF8F6A"}}),_c('path',{attrs:{"d":"M12.297.703h-6.75c-.5 0-.906.406-.906.906v3.735h7.671V.704h-.015z","fill":"#ED6B47"}}),_c('path',{attrs:{"d":"M16.25 15H1.75C.5 15 0 15 0 14.015v-8.03C0 5 .5 5 1.75 5h14.5C17.5 5 18 5 18 5.985v8.03c0 .985-.5.985-1.75.985z","fill":"#C8421D"}}),_c('path',{attrs:{"opacity":".2","d":"M18 5.908v8.136c0 .54-.411.956-1 .956H4.5l.031 1h13.392c.589 0 1.077-.447 1.077-.986V6.971c.016-.493-.495-1.001-1-1.063z","fill":"#000"}}),_c('path',{attrs:{"d":"M1.684 7.363V13h1.18v-1.75h1.113c1.187 0 2.011-.777 2.011-1.938 0-1.171-.793-1.949-1.953-1.949H1.684zm1.18.969h.859c.68 0 1.066.344 1.066.984 0 .633-.394.977-1.07.977h-.856V8.332zm4.21-.973V13h2.219c1.688 0 2.645-1.027 2.645-2.86 0-1.765-.97-2.78-2.645-2.78H7.074zm1.18 1.008h.851c1.024 0 1.63.653 1.63 1.793 0 1.192-.587 1.832-1.63 1.832h-.851V8.367zM14.23 13v-2.195h2.293V9.84H14.23V8.37h2.512V7.363h-3.691V13h1.18z","fill":"#fff"}})])
          )
        }
      }
    